export const TOAST_MESSAGE_TIMEOUT = 4000;
export const OPENED_TOASTS_LIMIT = 1;
export const MIN_TOAST_SHOWING_TIME = 2000;

export enum ToastMessageType {
  Success = 'success',
  Warning = 'warning',
}

export interface ToastMessage {
  toastId: number;
  message: string;
  type: ToastMessageType;
  timestamp: number;
  timeout: ReturnType<typeof setTimeout>;
  isHtmlMessage: boolean;
}
